import {
  CompareOptionGroup,
  CompareSelect,
} from '@/components/sections/product-compare/compare-selects/compare-select';
import { Grid } from '@/components/shared/layout/grid';

export interface CompareSelectsProps {
  selectedModelKeys: string[];
  optionGroups: CompareOptionGroup[];
  onModelChange: (index: number, modelKey: string) => void;
}
export const CompareSelects: React.FC<CompareSelectsProps> = ({
  selectedModelKeys,
  optionGroups,
  onModelChange,
}) => {
  return (
    <Grid
      templateColumns={{ '@initial': '2', '@lg': '3' }}
      columnGap={{ '@initial': '4', '@md': '6' }}
      css={{
        position: 'sticky',
        left: 0,
        top: 'var(--sticky-top)',
        width: '100%',
        bc: '$white',
        py: '$space-4',
        zIndex: '2',
      }}
    >
      {selectedModelKeys.map((modelKey, modelKeyIndex) => (
        <CompareSelect
          name={`dropdown_model_${modelKeyIndex}`}
          key={modelKeyIndex}
          index={modelKeyIndex}
          value={modelKey}
          options={optionGroups}
          onOptionChange={onModelChange}
          selectedParams={selectedModelKeys}
          css={
            modelKeyIndex === 2 ? { '@maxlg': { display: 'none' } } : undefined
          }
        />
      ))}
    </Grid>
  );
};
CompareSelects.displayName = 'CompareSelects';
